import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useInventory } from '../../../../../../contexts/InventoryContext';
import UnitDetailsBase from './UnitDetailsBase';

/**
 * Unit detail page for route: /inventory/projects/:projectId/configurations/:configurationId/units/:unitId
 * Loads project, config, and unit from API then renders UnitDetailsBase.
 */
export default function UnitDetail() {
  const { projectId, configurationId, unitId } = useParams();
  const { getProjectDetail, getConfig, fetchUnit } = useInventory();
  const [project, setProject] = useState(null);
  const [config, setConfig] = useState(null);
  const [unit, setUnit] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!projectId || !configurationId || !unitId) {
      setLoading(false);
      return;
    }
    setLoading(true);
    Promise.all([
      getProjectDetail(projectId),
      getConfig(projectId, configurationId),
      fetchUnit(projectId, configurationId, unitId),
    ])
      .then(([proj, cfg, u]) => {
        setProject(proj ?? null);
        setConfig(cfg ?? null);
        setUnit(u ?? null);
      })
      .catch(() => {
        setProject(null);
        setConfig(null);
        setUnit(null);
      })
      .finally(() => setLoading(false));
  }, [projectId, configurationId, unitId, getProjectDetail, getConfig, fetchUnit]);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 200, p: 3 }}>
        <CircularProgress size={32} sx={{ color: 'success.main' }} />
      </Box>
    );
  }
  if (!unit) {
    return (
      <Box sx={{ p: 3 }}>
        <Typography color="text.secondary">Unit not found.</Typography>
      </Box>
    );
  }

  return (
    <UnitDetailsBase
      projectId={projectId}
      configurationId={configurationId}
      unitId={unitId}
      unit={unit}
      project={project}
      config={config}
      onUnitUpdated={setUnit}
    />
  );
}
